import { Injectable } from '@angular/core';
import { async } from '@angular/core/testing';
import { BasicResponse } from 'src/app/core/models/basic-response.model';
import {
  getConnection,
  getCurrentUser,
  getEndpoint,
} from 'src/app/core/services/functions.service';
import { RequestsService } from 'src/app/core/services/requests.service';

@Injectable({
  providedIn: 'root',
})
export class ReportesService {
  urlBase = getEndpoint("CUOTAS")
  //urlBase = 'http://localhost:3000'
  constructor(private _RequestsService: RequestsService) { }

  async camPlanAplicados(company: string, fecha_ini: string, fecha_fin: string): Promise<BasicResponse> {
    let res = await this._RequestsService.get(this.urlBase + `v1/${company}/reportes/cam-plan-aplicados/`, {
      fecha_ini,
      fecha_fin
    });
    if(!res.success){
        throw new Error(res.error)
    }
    return res;
  }
}

